import { Typography } from "antd";
import { TabsAndTaskHistory } from "components/Shared/TabsAndTaskHistory";
import { useIntl } from "react-intl";
import { SeasonRosterTab } from "./components/SeasonRosterTab";
import { SeasonStaffTab } from "./components/SeasonStaffTab";

type Props = {
  viewOnly: boolean;
  isLoading: boolean;
  season: any;
  roster: Array<any>;
  staff: Array<any>;
  entityId: string;
};

export const SeasonView = ({ viewOnly, isLoading, season, roster, staff, entityId }: Props) => {
  const { formatMessage } = useIntl();

  const tabs = [
    {
      key: "roster",
      label: <Typography.Text className="text-upper">{formatMessage({ id: "rosterTab.title" })}</Typography.Text>,
      children: <SeasonRosterTab isLoading={isLoading} season={season} roster={roster} viewOnly={viewOnly} />,
    },
    {
      key: "staff",
      label: <Typography.Text className="text-upper">{formatMessage({ id: "staffTab.title" })}</Typography.Text>,
      children: <SeasonStaffTab isLoading={isLoading} season={season} staff={staff} viewOnly={viewOnly} />,
    },
  ];

  return (
    <TabsAndTaskHistory
      isLoading={isLoading}
      entityId={entityId}
      season={season}
      roster={roster}
      staff={staff}
      tabs={tabs}
    />
  );
};
